import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { OverviewEntity } from '../../models/overview.entities';
import * as APIActions from '../actions/api.actions';
import * as AEMActions from '../actions/content.actions';

export const OVERVIEW_FEATURE_KEY = 'overview';

export interface State extends EntityState<OverviewEntity> {
  selectedId?: string | number; // which Overview record has been selected
  loaded: boolean; // has the Overview list been loaded
  error?: string | null; // last known error (if any)
}

export const overviewAdapter: EntityAdapter<OverviewEntity> =
  createEntityAdapter<OverviewEntity>();

export const initialState: State = overviewAdapter.getInitialState({
  loaded: false
});

const overviewReducer = createReducer(
  initialState,
  on(AEMActions.loadAEMContentSuccess, (state, { aemContent }) =>
    overviewAdapter.setOne(aemContent, { ...state, loaded: true })
  ),
  on(AEMActions.loadAEMContentFailure, (state, { aemContentError }) =>
    overviewAdapter.setOne(aemContentError, { ...state, loaded: true })
  ),
  on(AEMActions.loadAEMSummaryContentSuccess, (state, { aemSummaryContent }) =>
    overviewAdapter.setOne(aemSummaryContent, { ...state, loaded: true })
  ),
  on(
    AEMActions.loadAEMSummaryContentFailure,
    (state, { aemSummaryContentError }) =>
      overviewAdapter.setOne(aemSummaryContentError, { ...state, loaded: true })
  ),
  on(AEMActions.loadAEMFeatureFlagsSuccess, (state, { aemFeatureFlags }) =>
    overviewAdapter.setOne(aemFeatureFlags, { ...state, loaded: true })
  ),
  on(AEMActions.loadAEMFeatureFlagsFailure, (state, { aemFeatureFlagsError }) =>
    overviewAdapter.setOne(aemFeatureFlagsError, { ...state, loaded: true })
  ),
  on(AEMActions.loadAEMWelcomeTourSuccess, (state, { aemWelcomeTour }) =>
    overviewAdapter.setOne(aemWelcomeTour, { ...state, loaded: true })
  ),
  on(AEMActions.loadAEMWelcomeTourFailure, (state, { aemWelcomeTourError }) =>
    overviewAdapter.setOne(aemWelcomeTourError, { ...state, loaded: true })
  ),
  on(AEMActions.loadAEMErrorMessagesSuccess, (state, { aemErrorMessages }) =>
    overviewAdapter.setOne(aemErrorMessages, { ...state, loaded: true })
  ),
  on(
    AEMActions.loadAEMErrorMessagesFailure,
    (state, { aemErrorMessagesError }) =>
      overviewAdapter.setOne(aemErrorMessagesError, { ...state, loaded: true })
  ),
  on(APIActions.loadMultiplePESuccess, (state, { personalizationEngine }) =>
    overviewAdapter.setOne(personalizationEngine, { ...state, loaded: true })
  ),
  on(APIActions.loadMultiplePEFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(APIActions.loadTrackerSuccess, (state, { tracker }) =>
    overviewAdapter.setOne(tracker, { ...state, loaded: true })
  ),
  on(APIActions.loadTrackerFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(APIActions.loadFutureActivitySuccess, (state, { futureActivities }) =>
    overviewAdapter.setOne(futureActivities, { ...state, loaded: true })
  ),
  on(APIActions.loadFutureActivityFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(APIActions.loadMembershipCardSuccess, (state, { membershipCards }) =>
    overviewAdapter.setOne(membershipCards, { ...state, loaded: true })
  ),
  on(APIActions.loadMembershipCardFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(APIActions.loadVouchersSuccess, (state, { vouchers }) =>
    overviewAdapter.setOne(vouchers, { ...state, loaded: true })
  ),
  on(APIActions.loadVouchersFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(APIActions.loadEDocsSuccess, (state, { eDocs }) =>
    overviewAdapter.setOne(eDocs, { ...state, loaded: true })
  ),
  on(APIActions.loadEDocsFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(APIActions.loadSnapshotSuccess, (state, { snapshot }) =>
    overviewAdapter.setOne(snapshot, { ...state, loaded: true })
  ),
  on(APIActions.loadSnapshotFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(APIActions.loadEarnsSummarySuccess, (state, { earnsSummary }) => {
    return overviewAdapter.setOne(earnsSummary, { ...state, loaded: true });
  }),
  on(APIActions.loadEarnsSummaryFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(APIActions.loadSkyClubTrackerSuccess, (state, { skyClubTracker }) => {
    return overviewAdapter.setOne(skyClubTracker, { ...state, loaded: true });
  }),
  on(APIActions.loadSkyClubTrackerFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(
    APIActions.loadAmexSkyClubTrackerSuccess,
    (state, { amexSkyClubTracker }) => {
      return overviewAdapter.setOne(amexSkyClubTracker, {
        ...state,
        loaded: true
      });
    }
  ),
  on(APIActions.loadAmexSkyClubTrackerFailure, (state, { error }) => {
    return overviewAdapter.setOne(error, { ...state, loaded: true });
  })
);

export const reducer = (state: State | undefined, action: Action) =>
  overviewReducer(state, action);
